import { render, staticRenderFns } from "./SliderSpecials.vue?vue&type=template&id=3dca1381"
import script from "./SliderSpecials.vue?vue&type=script&lang=js"
export * from "./SliderSpecials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports